import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  private http = inject(HttpClient);
  private oauthService = inject(OAuthService);

  downloadFile(url: string, defaultFilename: string = 'download'): Observable<void> {
    return new Observable<void>((observer) => {
      const headers = {
        'Authorization': `Bearer ${this.oauthService.getAccessToken()}`,
        'Accept': 'application/octet-stream, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, */*'
      };

      fetch(url, {
        method: 'GET',
        headers: headers,
        credentials: 'same-origin'
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          let filename = defaultFilename;
          const contentDisposition = response.headers.get('Content-Disposition');
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '');
            }
          }
          
          return response.blob().then(blob => ({ blob, filename }));
        })
        .then(({ blob, filename }) => {
          this.saveBlob(blob, filename);
          observer.next();
          observer.complete();
        })
        .catch(error => {
          console.error('File download error:', error);
          observer.error(error);
        });
    }).pipe(
      catchError(error => {
        console.error('FileDownloadService error:', error);
        return throwError(() => error);
      })
    );
  }

  downloadFromApiEndpoint(baseUrl: string, endpoint: string, defaultFilename: string = 'export'): Observable<void> {
    const fullUrl = `${baseUrl}/${endpoint}`;
    return this.downloadFile(fullUrl, defaultFilename);
  }

  /**
   * Download a blob directly to the user's device.
   */
  downloadBlob(blob: Blob, filename: string): void {
    this.saveBlob(blob, filename);
  }

  private saveBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    window.URL.revokeObjectURL(url);
  }
}